module.exports = __webpack_public_path__ + "img/solution-pc-30.c8d74d9b.png";